import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";
import { MAX_RECENT, RECENT_KEY } from "./globalSearchConstants";

function parseRecentJson(raw: string | null): string[] {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === "string") : [];
  } catch {
    return [];
  }
}

export async function loadGlobalSearchRecent(): Promise<string[]> {
  try {
    if (Platform.OS === "web") {
      if (typeof window === "undefined") return [];
      return parseRecentJson(window.localStorage.getItem(RECENT_KEY));
    }
    return parseRecentJson(await AsyncStorage.getItem(RECENT_KEY));
  } catch {
    return [];
  }
}

export async function persistGlobalSearchRecent(items: string[]): Promise<void> {
  const payload = JSON.stringify(items.slice(0, MAX_RECENT));
  try {
    if (Platform.OS === "web") {
      if (typeof window === "undefined") return;
      window.localStorage.setItem(RECENT_KEY, payload);
      return;
    }
    await AsyncStorage.setItem(RECENT_KEY, payload);
  } catch {
    return;
  }
}
